/** Copyright (c) 2022-present TVM Engineering Authors. */

import { createTheme } from "@mui/material";
import { backgroundColor } from "./defaultStyles";

const defaultTheme = createTheme();

const theme = createTheme({
  typography: {
    fontFamily: '"Roboto", sans-serif',
    fontWeightLight: 300,
    fontWeightMedium: 600,
    fontWeightRegular: 400,

    h1: {
      fontSize: "3.75rem",
      fontWeight: "300",
      lineHeight: "normal",
      color: "#393939",
    },
    h2: {
      fontSize: "3rem",
      color: "#393939",
    },
    h3: {
      fontSize: "2rem",
    },
    body1: {
      fontSize: "1.25rem",
      fontWeight: "300",
    },
  },
  palette: {
    // primary: {
    //   main: '#147AAE' // lightBlue.A400,
    // },
    // secondary: {
    //   main: '#4884b2' // colors.lightBlue['400']
    // }
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          // marginTop: '-9px'
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          // height: '0.5rem'
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "0px",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff", // '#2C1C4B ', // colors.lightBlue['700'],
          color: "#000", // colors.lightBlue.A400
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Roboto, sans-serif",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: "500",
          "&:hover": {},
          // background: '#8375ab !important'
        },
      },
      containedPrimary: {
        borderRadius: "0",
        "&:hover": {
          // background: '#8375ab !important'
        },
      },
      contained: {
        "&:hover": {
          background: "#0b98cf !important",
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          backgroundColor: "#2C1C4B", // '#3c3d41',
          color: "#ffffff",
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          color: "#2C1C4B",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: backgroundColor, // '#42335D',
        },
      },
    },
    MuiDrawer: {
      paperAnchorRight: {
        background: "#e4e5e6",
        width: "60%",
      },
      paperAnchorLeft: {
        background: backgroundColor, // '#42335D',
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingTop: "4px",
          paddingBottom: "4px",
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "#393939",
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          color: "#393939",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          margin: "5px 0px",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "#000000b3",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "#000000b3",
        },
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: "0.9em",
      },
      styleOverrides: {
        tooltip: {
          fontWeight: 400,
          fontFamily: "Roboto",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { position: "inherit" },
      },
    },
  },
  MuiTableRow: {
    root: {
      backgroundColor: "#f2f2f2",
    },
  },
  MUIDataTableHeadCell: {
    fixedHeader: {
      backgroundColor: "#f2f2f2",
    },
  },
  // Used by `getContrastText()` to maximize the contrast between the background and
  // the text.
  contrastThreshold: 3,
  // Used to shift a color's luminance by approximately
  // two indexes within its tonal palette.
  // E.g., shift from Red 500 to Red 300 or Red 700.
  tonalOffset: 0.2,
});

export default {
  defaultTheme,
  theme,
};
